var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3536 10.6464C18.5488 10.8417 18.5488 11.1583 18.3536 11.3536C18.1583 11.5488 17.8417 11.5488 17.6464 11.3536L18.3536 10.6464ZM12 5L11.6464 4.64645C11.8417 4.45118 12.1583 4.45118 12.3536 4.64645L12 5ZM6.35355 11.3536C6.15829 11.5488 5.84171 11.5488 5.64645 11.3536C5.45118 11.1583 5.45118 10.8417 5.64645 10.6464L6.35355 11.3536ZM18.3536 18.6464C18.5488 18.8417 18.5488 19.1583 18.3536 19.3536C18.1583 19.5488 17.8417 19.5488 17.6464 19.3536L18.3536 18.6464ZM6.35355 19.3536C6.15829 19.5488 5.84171 19.5488 5.64645 19.3536C5.45118 19.1583 5.45118 18.8417 5.64645 18.6464L6.35355 19.3536ZM12 13L11.6464 12.6464C11.8417 12.4512 12.1583 12.4512 12.3536 12.6464L12 13ZM17.6464 11.3536L11.6464 5.35355L12.3536 4.64645L18.3536 10.6464L17.6464 11.3536ZM12.3536 5.35355L6.35355 11.3536L5.64645 10.6464L11.6464 4.64645L12.3536 5.35355ZM5.64645 18.6464L11.6464 12.6464L12.3536 13.3536L6.35355 19.3536L5.64645 18.6464ZM12.3536 12.6464L18.3536 18.6464L17.6464 19.3536L11.6464 13.3536L12.3536 12.6464Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDouble);
export default __webpack_public_path__ + "static/media/chevron-up-double.c519aff03d1925d34bfb055f608e3256.svg";
export { ForwardRef as ReactComponent };